import React, { useContext } from 'react';
import '../styles/Header.scss';
import { LanguageContext } from '../context';

function Footer() {
  const { t, localizedDocumentUrl } = useContext(LanguageContext);

  return (
    <footer>
      <div className='flex flex-wrap justify-center items-center max-w-7xl mx-auto p-4 lg:p-6 gap-x-3 lg:gap-9'>

        <a target='_blank' rel='noreferrer' href={localizedDocumentUrl('application')} className='footer-link hover'>
          {t('footer.cgu_application')}
        </a>
        <a target='_blank' rel='noreferrer' href={localizedDocumentUrl('service')} className='footer-link hover'>
          {t('footer.cgu_service')}
        </a>
        <a target='_blank' rel='noreferrer' href={localizedDocumentUrl('privacy')} className='footer-link hover'>
          {t('footer.privacy_policy')}
        </a>
        <a target='_blank' rel='noreferrer' href={localizedDocumentUrl('cookies')} className='footer-link hover'>
          {t('footer.cookies_policy')}
        </a>
        <span className='footer-link'>
          {`©wecar-${new Date().getFullYear()}`}
        </span>
      </div>

    </footer>

  )
}

export default Footer
